'use client';

import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

interface KittingFlashOverlayProps {
  state: 'idle' | 'correct' | 'wrong';
  message: string;
  sub: string;
}

export default function KittingFlashOverlay({ state, message, sub }: KittingFlashOverlayProps) {
  if (state === 'idle') return null;

  return (
    <div
      className={`flash-overlay flash-animate ${
        state === 'correct' ? 'flash-green' : 'flash-red'
      }`}
      aria-live="assertive"
      role="alert"
    >
      <div className="flex flex-col items-center gap-4 text-white text-center px-8">
        {state === 'correct' ? (
          <CheckCircle2 size={80} strokeWidth={1.5} className="drop-shadow-lg" />
        ) : (
          <XCircle size={80} strokeWidth={1.5} className="drop-shadow-lg" />
        )}
        <div>
          <p className="text-4xl font-black tracking-wide drop-shadow-md">{message}</p>
          <p className="text-xl font-medium mt-2 opacity-90">{sub}</p>
        </div>
        <div className="mt-2 px-6 py-2 rounded-full bg-white/20 backdrop-blur-sm">
          <p className="text-sm font-semibold">
            {state === 'correct' ? '✓ Scan accepted' : '✗ Try again'}
          </p>
        </div>
      </div>
    </div>
  );
}